import React, { useRef, useState, useEffect } from 'react'
import { Swiper, SwiperSlide } from "swiper/react";
import { Controller } from "swiper";
import { useNavigate } from "react-router-dom";
import { Button, Typography, Box, Grid, Paper, ButtonGroup, IconButton, CircularProgress, Snackbar } from '@mui/material';
import MuiAlert from '@mui/material/Alert';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import AppNav from '../../components/appNav';
import placeholderImage from '../../assets/placeholder-image.jpeg'
import { useEvent } from '../../context/EventContext';
import { useManager } from '../../context/ManagerContext';
import { api, baseURL } from '../../services/api';
import 'swiper/css';
import 'swiper/css/bundle';
import * as qs from 'qs';




export default function Events() {
    let navigate = useNavigate()
    const customEventIds = [54]
    const [swiperRef, setSwiperRef] = useState(null);
    const { events, setEvents } = useEvent()
    const { manager } = useManager()
    const currentPage = useRef(1)
    const [loaded, setLoaded] = useState(false)
    const lastEvent = useRef(false)
    const query = useRef(null)
    const [stateAlert, setStateAlert] = React.useState({ status: false, type: 'success', msg: '' });
    const loadedEventIds = useRef(new Set()); // Referência para rastrear IDs já carregados


    const Alert = React.forwardRef(function Alert(props, ref) {
        return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
    });

    const handleResquest = async (page) => {
        query.current = qs.stringify({
            filters: {
                isActive: true,
                isVisible: true,
                deleted: false,
            },
            sort: ['position:asc','createdAt:desc'],
            populate: '*',
            pagination: {
                pageSize: 6,
                page: page || currentPage.current, // Usa a página passada ou a atual
            },
            encodeValuesOnly: true,
        });

        if (lastEvent.current) return;

        setLoaded(true);
        try {
            const { data } = await api.get('/events?' + query.current);

            if (!data.data.length) {
                setLoaded(false);
                lastEvent.current = true;
                return;
            }

            // Evitar duplicação de eventos usando a referência local
            const newEvents = data.data.filter(
                (newEvent) => !loadedEventIds.current.has(newEvent.id)
            );

            // Adicionar os novos IDs à referência local
            newEvents.forEach((event) => loadedEventIds.current.add(event.id));

            if (newEvents.length === 0) {
                setLoaded(false);
                return;
            }

            // Atualiza o estado com os novos eventos
            setEvents((prevEvents) => {
                const uniqueEvents = newEvents.filter(
                    (newEvent) => !prevEvents.some((event) => event.id === newEvent.id)
                );
                return [...prevEvents, ...uniqueEvents];
            });
            setLoaded(false);
        } catch (error) {
            setLoaded(false);
            throw error; // Propaga o erro para o chamador
        }
    };

    const handleEvent = (id) => {
        if (customEventIds.includes(Number(id)) && manager.fantasy == 'AGIP') {
            navigate(`event-custom/${id}`)
            return
        }
        navigate(`event/${id}`)
    }

    const handleNextEvents = async () => {
        // Incrementa a página temporariamente
        const nextPage = currentPage.current + 1;

        try {
            // Aguarda o carregamento dos novos eventos
            await handleResquest(nextPage);

            // Atualiza a página atual somente após o sucesso
            currentPage.current = nextPage;

            // Só chama slideNext se houver mais de 1 página de eventos
            if (swiperRef && typeof swiperRef.slideNext === 'function' && events.length >= 6) {
                swiperRef.slideNext();
            }
        } catch (error) {
            console.error('Erro ao carregar a próxima página:', error);

            // Reverte a página em caso de erro
            currentPage.current = nextPage - 1;
        }
    };

    useEffect(() => {
        // Garante que a página inicial seja carregada apenas uma vez
        currentPage.current = 1;
        handleResquest(currentPage.current).catch((error) => {
            console.error('Erro ao carregar eventos iniciais:', error);
            setStateAlert({
                status: true,
                type: 'error',
                msg: 'Erro ao carregar eventos! Tente novamente mais tarde!',
            });
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <>
            <Box sx={{ width: "100vw", height: "100vh", px: 0, m: 0, backgroundColor: "#EEEEEE" }}>
                <AppNav />
                <Snackbar
                    open={stateAlert.status}
                    autoHideDuration={2000}
                    anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                    onClose={() => setStateAlert({ status: false, type: 'error', msg: '' })} >
                    <Alert sx={{ width: '100%' }} severity={`${stateAlert.type}`}>
                        {stateAlert.msg}
                    </Alert>
                </Snackbar>
                <Grid container columns={12} spacing={3} p={5} sx={{ backgroundColor: "#EEEEEE" }}>
                    <Grid item xs={12} sm={12} md={12}>
                        <Box sx={{ display: "flex", width: '100%', px: 0, m: 0, textAlign: 'center', justifyContent: "space-between" }}>
                            <Typography sx={{ width: { xs: '0%', sm: '33%' } }}></Typography>
                            <Typography sx={{ width: { xs: '50%', sm: '33%' }, color: "#004D91", alignContent: 'center', textAlign: 'center', alignSelf: 'center', fontWeight: 700, fontSize: '1.5em' }}>
                                Próximos Eventos
                            </Typography>
                            <ButtonGroup sx={{ width: { xs: '50%', sm: '33%' }, display: 'flex', justifyContent: 'end' }}>
                                <IconButton aria-label="previus" onClick={() => swiperRef.slidePrev()}>
                                    <KeyboardArrowLeftIcon sx={{ fontSize: '1.5rem', color: "#004D91" }} />
                                </IconButton>
                                <IconButton aria-label="next" onClick={() => handleNextEvents()}>
                                    <KeyboardArrowRightIcon sx={{ fontSize: '1.5rem', color: "#004D91" }} />
                                </IconButton>
                            </ButtonGroup>
                        </Box>
                    </Grid>
                    {loaded ? <Grid item sx={{ textAlign: 'center' }} sm={12}><CircularProgress /></Grid> : null}
                    <Swiper
                        onSwiper={setSwiperRef}
                        onReachEnd={handleNextEvents}
                        centeredSlides={false}
                        slidesPerView={'auto'}
                        autoHeight={false}
                        loopedSlides={events.length + (manager?.isJoin ? 1 : 0)}
                        loop={false}
                        spaceBetween={40}
                        modules={[Controller]}
                        className="swiper"
                        style={{ padding: '25px 10px' }}
                    >
                        {/* Card de Filie-se se manager.isJoin for true */}
                        {manager.fantasy == 'APEPREV' && manager?.isJoin && (
                            <SwiperSlide style={{ maxWidth: '295px', width: '100%' }}>
                                <Paper elevation={3} sx={{ borderRadius: 3 }}>
                                    <Box sx={{ textAlign: 'right', backgroundColor: "#fff", borderRadius: 3, height: '555px', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                                        <Box style={{
                                            overflow: 'hidden',
                                            width: '100%', height: "369px",
                                            borderTopLeftRadius: 10, borderTopRightRadius: 10
                                        }}>
                                            <img
                                                alt='Filiação 2026'
                                                src={`${baseURL}/uploads/Whats_App_Image_2025_12_03_at_14_11_34_dba38871e1.jpeg`}
                                                style={{
                                                    width: '100%',
                                                    height: '100%',
                                                    objectFit: 'cover',
                                                    objectPosition: 'center',
                                                }}
                                            />
                                        </Box>
                                        <Typography variant={"body1"}
                                            sx={{
                                                display: '-webkit-box', overflow: 'hidden', WebkitBoxOrient: 'vertical', WebkitLineClamp: 2,
                                                textAlign: 'left', mx: 2, my: 1, fontWeight: 500,
                                                color: "#004D91", textTransform: 'uppercase'
                                            }}>
                                            Filiação 2026
                                        </Typography>
                                        <Box sx={{ display: "flex", mx: 2, mt: 1, textAlign: 'left', color: "#0097fe" }}>
                                            <Typography sx={{ display: '-webkit-box', overflow: 'hidden', WebkitBoxOrient: 'vertical', WebkitLineClamp: 2, textAlign: 'left', color: "#2A6393" }} variant={"body2"}>
                                               Boletos já disponíveis
                                            </Typography>
                                        </Box>
                                        <Button size="small" variant="contained" onClick={() => navigate('/filiese')} sx={{ m: 2, p: 1, backgroundColor: "#004D91" }}>
                                            Acessar Filiação e Renovação
                                        </Button>
                                    </Box>
                                </Paper>
                            </SwiperSlide>
                        )}
                        

                        {events.length > 0 ? events.map((event, index) => {
                            return (
                                <SwiperSlide key={event.id} style={{ maxWidth: '295px', width: '100%' }}>
                                    <Paper elevation={3} sx={{ borderRadius: 3 }}>
                                        <Box sx={{ textAlign: 'right', backgroundColor: "#fff", borderRadius: 3, height: '555px', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                                            <Box style={{
                                                overflow: 'hidden',
                                                width: '100%', height: "369px",
                                                borderTopLeftRadius: 10, borderTopRightRadius: 10
                                            }}>
                                                <img
                                                    alt='thumbnail'
                                                    src={event.attributes.thumbnail.data !== null ? baseURL + event.attributes.thumbnail.data.attributes.url : placeholderImage}
                                                    style={{
                                                        width: '100%',
                                                        height: '100%',
                                                        objectFit: 'cover',
                                                        objectPosition: 'center',
                                                    }}
                                                />
                                                {event.attributes.sold_out ?
                                                    <Box style={{ display: 'flex', backgroundColor: "rgba(0,0,0,0.6)", width: '100%', justifyContent: 'center', textAlign: 'center', height: "100%", borderTopLeftRadius: 10, borderTopRightRadius: 10 }}>
                                                        <Typography color={'#FF8787'} sx={{ alignSelf: 'center' }} variant={'h3'}>ESGOTADO</Typography>
                                                    </Box>
                                                    : null}
                                            </Box>
                                            <Typography variant={"body1"}
                                                sx={{
                                                    display: '-webkit-box', overflow: 'hidden', WebkitBoxOrient: 'vertical', WebkitLineClamp: 2,
                                                    textAlign: 'left', mx: 2, my: 1, fontWeight: 500,
                                                    color: "#004D91", textTransform: 'uppercase'
                                                }}>
                                                {event.attributes.name}
                                            </Typography>
                                            <Box sx={{ display: "flex", mx: 2, mt: 1, textAlign: 'left', color: "#0097fe" }}>
                                                <LocationOnIcon fontSize="small" />
                                                <Typography sx={{ display: '-webkit-box', overflow: 'hidden', WebkitBoxOrient: 'vertical', WebkitLineClamp: 2, textAlign: 'left', color: "#2A6393" }} variant={"body2"}>
                                                    {event.attributes.location_address}</Typography>
                                            </Box>
                                            <Button size="small" variant="contained" onClick={() => handleEvent(event.id)} sx={{ m: 2, p: 1, backgroundColor: "#004D91" }}>
                                                INFORMAÇÃO & INSCRIÇÃO
                                            </Button>
                                        </Box>
                                    </Paper>
                                </SwiperSlide>
                            )
                        }
                        ) : <SwiperSlide></SwiperSlide>}
                    </Swiper>
                </Grid>
            </Box>
        </>
    )
}